module.exports = function isCops(ps, user) {
    if (ps.cops) {
        const cops = ps.cops.filter((e) => e === user._id);
        if (cops.length > 0) {
            return true;
        }
    }
    if (ps.subprocesses) {
        for (let i = 0; i < ps.subprocesses.length; i++) {
            const process = ps.subprocesses[i];
            const cops = process.cops.filter((e) => e === user._id);
            if (cops.length > 0) {
                return true;
            }
        }
    }
    return false;
}